export const SESSION_END_MESSAGE_MINUTES = 44;
export const SESSION_END_MESSAGE_MS = SESSION_END_MESSAGE_MINUTES * 60 * 1000;
export const MAX_SESSION_TIME_MINUTES = 1440;
export const MAX_SESSION_TIME_HOURS = Math.floor(MAX_SESSION_TIME_MINUTES / 60);
export const EVENT_SESSION_TIME_MS = 'sessionTimeMs';
export const DEVICE_SESSION_KEY = 'account-tur.sessionEndMessage';
export const INACTIVITY_SAFETY_MARGIN_MS = 10 * 1000;

export const dialogTags = {
  INACTIVITY: 'real-time-inactivity',
} as const;

export type DialogTag = (typeof dialogTags)[keyof typeof dialogTags];
